import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { IFormattedProviderProps } from './provider-data';
import { TableCell } from '../../../components/table/TableCell';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';
import React from 'react';
import { ProviderLayout } from '../../../components/provider/ProviderLayout';
import { RelatedMerchants } from '../../../components/provider/RelatedMerchants';
import { DateComponent } from '../../../components/DateComponent';

export enum QuarantinedProvidersTableAccessorKeys {
  partner = 'partnerId',
  name = 'name',
  merchantNumber = 'merchantNumber',
  relatedMerchantsCount = 'relatedMerchantsCount',
  status = 'status',
  enteredQuarantineOn = 'quarantine_AddedOn',
  autoReleaseOn = 'autoReleaseOn',
}

export const defaultQuarantinedProviderColumnSizing: ColumnSizing = {
  [QuarantinedProvidersTableAccessorKeys.partner]: 100,
  [QuarantinedProvidersTableAccessorKeys.name]: 150,
  [QuarantinedProvidersTableAccessorKeys.merchantNumber]: 50,
  [QuarantinedProvidersTableAccessorKeys.relatedMerchantsCount]: 50,
  [QuarantinedProvidersTableAccessorKeys.status]: 100,
  [QuarantinedProvidersTableAccessorKeys.enteredQuarantineOn]: 100,
  [QuarantinedProvidersTableAccessorKeys.autoReleaseOn]: 100,

};

export const defaultQuarantinedProviderColumns: MRT_ColumnDef<IFormattedProviderProps>[] = [
  {
    accessorKey: QuarantinedProvidersTableAccessorKeys.partner,
    header: 'Partner',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Partner</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        <RelatedEntityNameLink id={renderedCellValue} type={RELATED_ENTITY_TYPE.PARTNER} />
      </TableCell>
    )
  },
  {
    accessorKey: QuarantinedProvidersTableAccessorKeys.name,
    header: 'Provider',
    enableSorting: false,
    Header: <span className="text-muted fw-bolder main-font-family fs-9">Provider</span>,
    Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        <ProviderLayout providerId={row?.original?.id}>
          <div className="fc-text-overflow">
            {renderedCellValue ? renderedCellValue : '-'}
          </div>
        </ProviderLayout>
      </TableCell>
    )
  },
  {
    accessorKey: QuarantinedProvidersTableAccessorKeys.relatedMerchantsCount,
    header: 'Related merchants',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Related merchants</span>,
    Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={false}
      >
        <RelatedMerchants
          name={renderedCellValue}
          secondaryName='-'
          relatedMerchantsList={row?.original?.relatedMerchants}
          relatedMerchantsCount={renderedCellValue}
          additionalClass='fs-9'
        />
      </TableCell>
    )
  },
  {
    accessorKey: QuarantinedProvidersTableAccessorKeys.merchantNumber,
    header: 'Merchant number',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Merchant number</span>,
    Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={false}
      >
        <ProviderLayout providerId={row?.original?.id}>
          <div className="fc-text-overflow">
            {renderedCellValue ? renderedCellValue : '-'}
          </div>
        </ProviderLayout>
      </TableCell>
    )
  },
  {
    accessorKey: QuarantinedProvidersTableAccessorKeys.enteredQuarantineOn,
    header: 'Entered quarantine on',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Entered quarantine on</span>,
    Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={false}
      >
        <ProviderLayout providerId={row?.original?.id}>
          <DateComponent
            value={renderedCellValue}
            isTime
          />
        </ProviderLayout>
      </TableCell>
    )
  },
];
